export default angular
  .module("ModifyRelationsCtrl", [
    "angularUtils.directives.dirPagination",
    "ui.bootstrap",
  ])
  .controller("ModifyRelationsController", [
    "$scope",
    "relationsData",
    "$state",
    "$modalInstance",
    "$modal",
    "$stateParams",
    "$http",
    "$rootScope",
    "$translate",
    "Scripts",
    function (
      $scope,
      relationsData,
      $state,
      $modalInstance,
      $modal,
      $stateParams,
      $http,
      $rootScope,
      $translate,
      Scripts,
    ) {
      $scope.ok = function () {
        Scripts.updateScriptMessageRelations(
          $scope.relations,
          $rootScope.pageID,
          relationsData.MESSAGE_ID,
          () => {
            $modalInstance.close();
          },
        );
      };
      $scope.cancel = function () {
        $modalInstance.dismiss("cancel");
      };
      Scripts.loadMessageRelations(relationsData, (data) => {
        $scope.relations = data;
        for (let i = 0; $scope.relations.length > i; i++) {
          if ($scope.relations[i].MESS_ID) {
            $scope.relations[i].CHECKED = true;
          } else {
            $scope.relations[i].CHECKED = false;
          }
          $scope.relations[i].SCRIPT_ID = $rootScope.pageID;
          $scope.relations[i].MESSAGE_ID = relationsData.MESSAGE_NUMBER;
          $scope.relations[i].MESS_ID = relationsData.MESSAGE_ID;
          $scope.relations[i].ALIAS_ID = $scope.relations[i].SYS_ID;
          $scope.relations[i].ALIAS_NAME = $scope.relations[i].NAME;
        }
      });
    },
  ]);
